// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Events Configuration
 * 
 * Contains all warp event settings, probabilities, and outcomes.
 */

export const eventsConfig = {
  // Event generation during warp
  warpEvents: {
    enabled: true,
    minDelay: 5000,           // Minimum delay between events (ms)
    maxDelay: 15000,          // Maximum delay between events (ms)
    generationChance: 0.7,    // 70% chance of event when checked
    testEventDelay: 3000      // Test event delay for debugging (ms)
  },
  
  // Event generation while idle at stations
  idleEvents: {
    enabled: true,
    minDelay: 30000,          // Minimum delay (ms)
    maxDelay: 60000,          // Maximum delay (ms)
    generationChance: 0.3     // 30% chance of event when checked
  },
  
  // Event history limit
  maxEventHistory: 50,
  
  // Event-specific outcomes and damage
  asteroidField: {
    damageChance: 0.6,        // 60% chance of damage if ignored
    minDamage: 5,
    maxDamage: 15,
    evadeFuelCost: 5          // Fuel cost to evade
  },
  
  distressSignal: {
    rescueChance: 0.4,        // 40% genuine rescue
    trapChance: 0.3,          // 30% pirate trap (cumulative 0.7)
    salvageChance: 0.3,       // 30% abandoned salvage (remaining)
    rescueReward: 150,        // Credits for rescue
    salvageReward: 250,       // Credits for salvage
    investigateFuelCost: 10   // Fuel cost to investigate
  },
  
  nebula: {
    damageChance: 0.4,        // 40% chance of sensor damage
    minDamage: 3,
    maxDamage: 10,
    scanFuelCost: 3,          // Fuel cost to scan
    bypassFuelCost: 8         // Fuel cost to bypass
  },
  
  spaceStation: {
    bypassFuelCost: 8         // Fuel cost to bypass station
  },
  
  gravityWell: {
    damageChance: 0.5,        // 50% chance of structural damage
    hullDamageMin: 10,
    hullDamageMax: 20,
    engineDamageMin: 5,
    engineDamageMax: 12,
    shutdownFuelCost: 10,     // Fuel cost for emergency shutdown
    powerThroughFuelCost: 15  // Fuel cost to power through
  },
  
  pirateAmbush: {
    escapeChance: 0.3,        // 30% chance pirates catch up anyway
    emergencyWarpFuelCost: 20 // Fuel cost for emergency warp
  },
  
  mysteriousSignal: {
    successChance: 0.4,       // 40% success
    successReward: 200,       // Credits for success
    failureHullMin: 15,
    failureHullMax: 25,
    failureEngineMin: 10,
    failureEngineMax: 18,
    failureShieldMin: 8,
    failureShieldMax: 14
  },
  
  anomalyInvestigation: {
    systemDamageMin: 5,
    systemDamageMax: 15,
    avoidFuelCost: 5          // Fuel cost to avoid anomaly
  },
  
  evasionManeuver: {
    engineDamageMin: 3,
    engineDamageMax: 8,
    fuelCost: 15              // Fuel cost for evasion
  },
  
  anomalyAnalysis: {
    energyBoostChance: 0.4,   // 40% chance (outcome > 0.6)
    energyBoostCredits: 150,
    energyDrainChance: 0.3,   // 30% chance (0.3 < outcome <= 0.6)
    energyDrainFuel: 10
  },
  
  fuelDepot: {
    refuelCost: 100           // Credits for full refuel at depot
  }
};
